<ng-container *transloco="let t;">
<!-- Invite to sign Modal -->
<div>
    <div class="modal-header">
        <h4 class="modal-title">{{t("More tab invite to sign text (More tab) - Invite to sign")}}</h4>
        <button type="button" class="close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="inviteToSign" (ngSubmit)="onSubmit()">
    <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="intiveToView-fields-container">
                <div class="row">
                    <div formGroupName="recipient">
                        <div class="row">
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="firstname" >{{t("First name (general) - First name")}}</label>
                                    <input type="text" class="form-control" id="firstname" formControlName="firstname" [ngClass]="{'is-invalid error': (submitted && inviteToSign.get('recipient.firstname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="lastname" >{{t("Last name (general) - Last name")}}</label>
                                    <input type="text" class="form-control" id="lastname" formControlName="lastname" [ngClass]="{'is-invalid error': (submitted && inviteToSign.get('recipient.lastname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="email">{{t("Email (general) - Email")}}</label>
                                    <input type="email" class="form-control" id="email"  formControlName="email" [ngClass]="{'is-invalid error': (submitted && inviteToSign.get('recipient.email')?.errors)}"/>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="phone_no">{{t("Phone (general) - Phone")}}</label>
                                    <app-phone-input [formControl]="inviteToSign.get('recipient.phone_no')" [isFormSubmitted]="submitted"></app-phone-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-md-12 col-12 mb-25">
                        <label for="phone_no">{{t("Invitation message field label text (General) - Message")}}</label>
                        <div class="form-group intiveToView-fields">
                            <ng-select [items]="invitationThrough" bindLabel="name" bindValue="value" formControlName="invitation_type" [clearable]="false" [searchable]="true" [placeholder]='t("Invitation message field placeholder text (General) - Write your message")' (change)="onChangeInvitation($event)"> </ng-select>
                        </div>
                    </div>
                    <div class="col-xl-12 col-md-12 col-12 mb-25" *ngIf="inviteToSign?.get('invitation_type')?.value !== 'sms'">
                        <label class="col-form-label pt-0" for="message">{{t("Invitation message text (Template/Document - section) - Your invitation message")}}</label>
                        <div class="form-group intiveToView-fields">
                            <textarea class="form-control invitation_message" id="message" rows="3" [placeholder]="t('Invitation message text (Template/Document - section) - Your invitation message')" formControlName="message"></textarea>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="modal-footer">
        <button [disabled]="inviteToSignLoader" type="submit" class="btn btn-primary" rippleEffect>
            {{t("More tab invite to sign text (More tab) - Invite to sign")}} <span *ngIf="inviteToSignLoader" class="spinner-border spinner-border-sm ms-50"></span>
        </button>
    </div>
    </form>
</div>
<!-- / Invite to sign Modal -->
</ng-container>